import React from 'react';
import "../Css/LoginScreen.css";


function NotFound() {
  return (
    <div className='flex row loginScreen center container'>
    <h1>chyba zabłądziłeś</h1>
    </div>
  );
}

export default NotFound;